var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1FairStand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 18v42a4 4 0 01-4 4H45v-4h18V18H13v42h6v4h-6a4.17 4.17 0 01-4-3.77V18a4.06 4.06 0 014-4h50a4 4 0 014 4zM44 37h14v-3H44v3zm14-12v-3H44v3h14zm-14 6h8v-3h-8v3zm2.92 20H17v4h6v9h18v-9h5.92v-4zM23 45.09V48h18v-3a4 4 0 00-4-4H26.73A3.851 3.851 0 0023 45.09zM36.79 34.5a4.5 4.5 0 10-4.5 4.5 4.49 4.49 0 004.5-4.5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Fair_stand.d7030f5b.svg";
export { SvgK1FairStand as ReactComponent };